import { H01_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H01/plasmic-props";
import { H02_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H02/plasmic-props";
import { H03_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H03/plasmic-props";
import { H04_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H04/plasmic-props";
import { H05_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H05/plasmic-props";
import { H06_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H06/plasmic-props";
import { H07_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H07/plasmic-props";
import { H08_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/H08/plasmic-props";

import { HERO_VARIANTS, H_01 as HERO_H01 } from "@stadium/shared/src/helpers/plasmic/static-slices";

export const HERO_PLASMIC_PROPS = {
  variant: {
    type: "choice",
    options: HERO_VARIANTS,
    defaultValue: HERO_H01,
    description: "Select hero variant",
  },
  ...H01_PLASMIC_PROPS,
  ...H02_PLASMIC_PROPS,
  ...H03_PLASMIC_PROPS,
  ...H04_PLASMIC_PROPS,
  ...H05_PLASMIC_PROPS,
  ...H06_PLASMIC_PROPS,
  ...H07_PLASMIC_PROPS,
  ...H08_PLASMIC_PROPS,

  id: {
    type: "string",
    defaultValue: "",
    description: "HTML id attribute",
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
